import { WorkqueueService } from './../../../BaseFramework/core/http/workqueue.service';
import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { ApiRequestService } from 'app/BaseFramework/core/http/api-request.service';
import { AppMetadataHandler } from 'app/BaseFramework/configs/app-metadata.handler'
import { TranslateService } from 'app/BaseFramework/core/http/translate.service';
import { CommonUtilty } from 'app/BaseFramework/core/utilities/commonUtility';
import { PolicyIO, InteractService, ProposalIO } from 'app';
import { DataTransformService } from '../data-transform/data-transform.service';


@Injectable({
  providedIn: 'root'
})
export class CustomHookService {
  constructor(
    private apiRequestService: ApiRequestService,
    private translate: TranslateService,
    private commonUtilty: CommonUtilty,
    private dataTransformService: DataTransformService,
    private interactService: InteractService,
    private workqueueService: WorkqueueService
  ) { }

  fetchAPIMetaData(apiName: any): Observable<any> {
    let me = this;

    let APIMetaDataDataSubject = new Subject<any>();

    let pathVariables = [];
    pathVariables.push(apiName);
    this.apiRequestService.getCallWithAPIMapper('fetchByAPIName', null, null, pathVariables)
      .subscribe(jsonResp => {
        let returnObj = jsonResp;
        console.log(returnObj);
        APIMetaDataDataSubject.next(returnObj);
      });

    return APIMetaDataDataSubject;
  }

  getBillItemSubItemMetaData(itemCd, subItemCd): Observable<any> {
    let APIMetaDataDataSubject = new Subject<any>();
    if (itemCd && subItemCd) {
      let endpoint = `billItem/itemCd/${itemCd}/subItemCd/${subItemCd}`
      this.apiRequestService.get(endpoint).subscribe(response => {
        if (response) {
          let configData = { ...response.billItemDO }
          APIMetaDataDataSubject.next(configData);
        }
        else {
          console.error("Received Empty Response", endpoint)
        }
      })
    }
    else
      console.log(`itemCd or subItemCd, is empty`);

    return APIMetaDataDataSubject;
  }

  getSubItemList(itemCd): Observable<any> {
    let APIMetaDataDataSubject = new Subject<any>();

    if (itemCd) {
      let endpoint = 'getSubItemList'
      let pathVariables = [];
      pathVariables.push(itemCd);
      this.apiRequestService.getCallWithAPIMapper(endpoint, null, null, pathVariables).subscribe(response => {
        let configData = this.commonUtilty.deepCopy(response)
        APIMetaDataDataSubject.next(configData);
      })
    }
    else
      console.log(`itemCd is empty`);

    return APIMetaDataDataSubject;
  }

  fetchProducts(): Observable<any> {
    let me = this;
    // api/product/fetchByPlantypeAndProductFamilyAndEntryDate/{planTypeCd}/{productFamilyCd}/{submissionMode}/{proposalEntryDate}
    let body = {
      planTypeCd: 'BASEPLAN',
      productFamilyCd: 'HEALTH',
      submissionMode: 'PAPER',
      proposalEntryDate: new Date().getTime()
    }
    let data = body.planTypeCd + "/" + body.productFamilyCd + "/" + body.submissionMode + "/" + body.proposalEntryDate;
    let FetchProductSubject = new Subject<any>();
    this.apiRequestService.get('api/product/fetchByPlantypeAndProductFamilyAndEntryDate/' + data)
      .subscribe(jsonResp => {
        let returnObj = this.commonUtilty.deepCopy(jsonResp);
        FetchProductSubject.next(returnObj);
      });

    return FetchProductSubject;
  }

  getMandatoryCoverages() {
    // temp code
    let mainProductFound = false;
    let proposalIO = new ProposalIO();
    let coverageSubject = new Subject<any>();

    proposalIO.proposalDO.baseProductCd = this.dataTransformService.activeTransactionStore['AppConstants']['productCd'];
    // proposalIO.proposalDO.baseProductCd = productCd
    proposalIO.proposalDO.baseProductFamilyCd = 'HEALTH'
    proposalIO.proposalDO.submissionModeCd = "PAPER"
    // }
    let url = 'api/policy/fetchRidersAssociationsForBaseProduct'
    this.apiRequestService.postCallWithAPIMapper(url, proposalIO).subscribe(resp => {
      console.log("product association api response", JSON.stringify(resp));
      let returnObj = this.commonUtilty.deepCopy(resp);
      coverageSubject.next(returnObj);
    });
    return coverageSubject;
  }

  setProductCd(productCd) {
    this.dataTransformService.activeTransactionStore['AppConstants']['productCd'] = productCd
    // return "HEALTHCAREINSURANCE"
    // return of(true)
  }

  fetchCoverages(): Observable<any> {
    let coverageSubject = new Subject<any>();
    let productCd = this.dataTransformService.activeTransactionStore['AppConstants']['productCd'];
    if (productCd) {
      this.workqueueService.fetchRiders(productCd)
        .subscribe(jsonResp => {
          console.log("coverages response", JSON.stringify(jsonResp));
          if (jsonResp && jsonResp.length) {
            jsonResp.forEach((criteria: any) => {
              console.log("criteria", JSON.stringify(criteria));
              if (criteria[2] == 'OPTIONAL') {
                let lookupObj = { lookupKey: criteria[1], lookupValue: criteria[0] }
                coverageSubject.next([lookupObj])
              }
            })
          }
        })
    }
    return coverageSubject;
  }


  insuredlistSubject$
  insuredList = [];
  customHookInsuredList() {
    this.insuredlistSubject$ = this.interactService.addClientSubject$.subscribe(res => {
      console.log("client list in product coverages component", JSON.stringify(res));

      if (res != null) {
        if (res.role == 'PRIMARYINSURED' || res.role == 'INSURED' || res.role == 'Primary Insured' || res.role == 'Insured') {
          let insured = { guid: res.clientDO.guid, name: res.clientDO.personDO.firstName + " " + res.clientDO.personDO.lastName }
          this.commonUtilty.addLookupDataToCache(insured.guid, insured.name, "insuredCd");

          let insuredObj = { clientDO: res.clientDO }
          this.insuredList.push(insuredObj);
        }
      }
    })
  }

}
